import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let RouterPathMixin = class RouterPathMixin extends Vue {
    /* Temporary set to method for future development */
    isAppsPath() {
        return this.fullPath('/apps');
    }
    isAffiliatePath() {
        return this.fullPath('/affiliate');
    }
    isAffiliateMerchantDiy() {
        return this.getRouteFirstMatchedPath('/affiliate-v2');
    }
    isDiy() {
        return this.getRouteFirstMatchedPath('/diy') || this.isAffiliateMerchantDiy();
    }
    isLogin() {
        return this.getRouteFirstMatchedPath('/login');
    }
    isHomePage() {
        return this.fullPath('/');
    }
    isSalesPartnerPage() {
        return (this.getRouteName('affiliate-manager') ||
            this.getRouteName('affiliate-invites') ||
            this.getRouteName('affiliate-activated-apps') ||
            this.getRouteName('affiliate-signed-up-apps') ||
            this.getRouteName('affiliate-payouts'));
    }
    isNetworkDistributorPage() {
        return (this.getRouteName('reseller-mini-apps-overview') ||
            this.getRouteName('reseller-merchants-by-status') ||
            this.getRouteName('reseller-specific-merchant-details') ||
            this.getRouteName('reseller-specific-merchant-settings') ||
            this.getRouteName('reseller-specific-merchant-billings') ||
            this.getRouteName('reseller-mini-apps'));
    }
    isAccountPage() {
        return this.getRouteFirstMatchedPath('/profile');
    }
    isWithinLandingSiteMap() {
        const siteMapPaths = [
            '/',
            '/pricing',
            '/about',
            '/terms',
            '/press',
            '/contact-us',
            '/features',
            '/merchants',
            '/grab-integration',
            '/sales-partner',
            '/sales-partner/get-started',
            '/bpi-integration',
            '/sales',
            '/gcash-integration',
            '/team',
        ];
        return siteMapPaths.includes(this.$route.path);
    }
    isFillHeightView() {
        return (this.getRouteName('email-recipient-confirmation') || this.getRouteName('email-confirmation'));
    }
    isOverview() {
        return this.getRouteName('ecommerce-overview');
    }
    isShopifyOverview() {
        return this.getRouteName('shopify-overview');
    }
    isAffiliateOverview() {
        return this.getRouteName('affiliate-overview');
    }
    isPerformance() {
        return this.getRouteName('ecommerce-performance');
    }
    isProducts() {
        return this.getRouteName('ecommerce-products');
    }
    isCategories() {
        return this.getRouteName('ecommerce-categories');
    }
    isPayout() {
        return this.getRouteName('affiliate-payouts');
    }
    fullPath(path) {
        return this.$router.currentRoute.fullPath === path;
    }
    getRouteName(pathName) {
        return this.$route.name === pathName;
    }
    getRouteFirstMatchedPath(pathName) {
        return this.$route.matched[0]?.path?.includes(pathName);
    }
    isAdsPath() {
        const adsPaths = ['/ads-manager', '/create-ad'];
        console.log('ads path', adsPaths.includes(this.$route.path));
        return adsPaths.includes(this.$route.path);
    }
};
RouterPathMixin = __decorate([
    Component
], RouterPathMixin);
export default RouterPathMixin;
